export default __webpack_public_path__ + "static/media/note-text.c6672575.svg";